export type NotificationApi = {
  idNotificacion: number;
  tipo: NotificationApiTypes;
  descripcionTipo: string;
  descripcion: string;
  fecha: string;
  codigoCrm: string | null;
  leida: boolean;
  urgente: boolean;
  idBorrador: number | null;
  tipoTramite: string | null;
};

export enum NotificationApiTypes {
  TRAMITE_TYPE = 'TRAMITE',
  CONTRATO_TYPE = 'CONTRATO',
  FACTURA_TYPE = 'FACTURA',
  BORRADOR_TYPE = 'BORRADOR',
  MERCADO_TYPE = 'MERCADO',
  ACCIONA_TYPE = 'ACCIONA',
  USUARIOS_TYPE = 'USUARIOS',
  ERROR_CRM_TRAMITE = 'ERROR_CRM_TRAMITE',
}

export enum NotificationPaths {
  ALL = 'todos',
  URGENT = 'urgentes',
  ARCHIVED = 'archivadas',
  ALERT = 'alertas',
}
